import { } from "../../containers";
import BillList from "./components/BillList";
import Breadcrumb from "./components/Breadcrumb";

function Bills() {
    return (
        <>
        <Breadcrumb />
        <BillList />
        </>
    );
}
export default Bills;